import { useEffect, useState } from "react";
import { ArrowUpIcon } from "@heroicons/react/24/solid";

export default function ScrollTopButton() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 200);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      onClick={() =>
        window.scrollTo({ top: 0, behavior: "smooth" })
      }
      className="fixed bottom-6 right-6 z-50 rounded-full bg-primary p-3 text-white shadow-lg
                 transition hover:bg-primary/90 focus:outline-none"
      aria-label="Lap tetejére"
    >
      <ArrowUpIcon className="h-5 w-5" />
    </button>
  );
}
